const Scroll = {
  mounted() {
    this.target = this.el.dataset.scrollTarget ? document.querySelector(this.el.dataset.scrollTarget) : window
    this.target = this.target || window
    this.toTop()

    window.addEventListener('phx:page-loading-stop', this.toTop.bind(this))
  },
  destroyed() {
    window.removeEventListener('phx:page-loading-stop', this.toTop.bind(this))
  },
  toTop() {
    this.target.scroll(0, 0)
  },
}

export default Scroll
